import { render, staticRenderFns } from "./GoldWallet.vue?vue&type=template&id=31437495&scoped=true&"
import script from "./GoldWallet.vue?vue&type=script&lang=js&"
export * from "./GoldWallet.vue?vue&type=script&lang=js&"
import style0 from "./GoldWallet.vue?vue&type=style&index=0&id=31437495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31437495",
  null
  
)

export default component.exports